module.exports = __webpack_public_path__ + "static/img/js.459c07b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/frontProJect/fangzhou/js.png
// module id = m557
// module chunks = 1